import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import saveAs from 'file-saver';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { DepartmentAppVerificationModel } from 'src/app/models/department-app-verification.model';
import { Table } from 'primeng/table';
import { TokenService } from 'src/app/services/common/token.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { BankDetail } from '../../../registration/bank-details/bankDetails';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';

@Component({
  selector: 'app-farmer-application-verification-pending',
  templateUrl: './farmer-application-verification-pending.component.html',
  styleUrls: ['./farmer-application-verification-pending.component.scss']
})
export class FarmerApplicationVerificationPendingComponent implements OnInit {
  @ViewChild('appVerificationTable', { static: true })
  public appVerificationTable: Table;

  addBankDialog: boolean;
  fileName = 'ExcelSheet.xlsx';
  bankAccountList: BankDetail[] = [];

  bankAccount: BankDetail;

  selectedBankAccounts: BankDetail[];

  submitted: boolean;
  appVerificationItems: MenuItem[];
  vendorEstVerificationItems: MenuItem[];

  statuses: any[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  farmerId: any;
  bankList: any;
  filteredBankList: any[];
  appVerificationModel: DepartmentAppVerificationModel[];
  miDetailsByAppId: any;
  _appID: any;

  ipAddress: any;
  public userID: any;
  public status: any;
  public multiSortMeta: any;

  public loading: boolean = false;
  public subscriptions: any = [];

  public subjectSub:any;
  public selectedYear:any;

  constructor(
    private messageService: MessageService,
    private deptDashBoardService: DepartmentDashboardService,
    private router: Router,
    private dashboard: DashboardService,
    private tokenService: TokenService,
    private cryptoJsService: CryptoJsService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService
  ) {}

  ngOnInit() {
    this.multiSortMeta = [];
    this.multiSortMeta.push({field: 'registerationDate', order: 1});
    this.multiSortMeta.push({field: 'PreviousActionDate', order: 1});
    sessionStorage.setItem('currentComponent', 'FarmerApplicationForApprovalPending');
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    // this.loadData();
    this.loadDataAndApplyFilter();
    // this.appVerificationTable.filters['Status_Ar'] = [
    //   { value: 'P', matchMode: 'startsWith', operator: 'and' },
    // ];
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'App_Verification_List');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.appVerificationModel,
            'App_Verification_List'
          );
        },
      },
    ];
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        // this.appVerificationTable.clear();

        // let router=this.router.url
        // this.routePath=router.split('/')

        this.loadData();
   
        this.selectedYear = res;
        this.appVerificationTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  onFiltering(event: any) {
    // console.log('Filtered value: ' + JSON.stringify(event.filters));
  }

  loadData() {
    if (sessionStorage.getItem('FarmerApplicationForApprovalPending')) {
      this.appVerificationModel = JSON.parse(
        window.sessionStorage.getItem('FarmerApplicationForApprovalPending')
      );
      this.activityRecordService.activityRecord(this.userID, 'Farmer Applications For Approval (Pending)', '', new Date(), 'Success');

    } else {
      let sessionToken = sessionStorage.getItem('token');
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      // this.loader.start();
      this.loading = true;
      let sub = this.deptDashBoardService
        .GetDepartmentDashboard(JSON.parse(payload)?.sub, 'Pending')
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            data.AppVerification.forEach(e=>{
              e.registerationDate=new Date(e.registerationDate)
              e.registerationDate_filter=e.registerationDate.toString().substring(4, 24)
            })
            this.activityRecordService.activityRecord(this.userID, 'Farmer Applications For Approval (Pending)', '', new Date(), 'Success');
            if (data.AppVerification?.length > 0) {
              this.appVerificationModel = data.AppVerification;
              sessionStorage.setItem(
                'FarmerApplicationForApprovalPending',
                JSON.stringify(this.appVerificationModel)
              );
            }
          },
          error: (err) => {
            // this.loader.close();
            this.appVerificationModel = [];
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Farmer Applications For Approval', '', new Date(), err);
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          },
        });

        this.subscriptions.push(sub);
    }
    // if ((JSON.parse(sessionStorage.getItem('FarmerApplicationForApproval'))?.appID) == this._appID) {
    //   this.physicalVerficationData = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
  }

  refreshTable() {
    sessionStorage.removeItem('FarmerApplicationForApprovalPending');
    // this.loadData();
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
    this.loadDataAndApplyFilter();
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'AppUserType', header: 'App User Type' },
      { field: 'appID', header: 'APP ID' },
      { field: 'farmerName', header: 'Farmer Name' },
      { field: 'ApplicantType', header: 'Applicant Type' },
      { field: 'NextLevelID', header: 'Next Level ID' },
      { field: 'Scheme_Code', header: 'Scheme Code' },
      { field: 'TargetDays', header: 'Target Days' },
      { field: 'block', header: 'Block' },
      { field: 'district', header: 'District' },
      { field: 'registerationDate', header: 'Registration Date' },
      { field: 'remarks', header: 'Remarks' },
      { field: 'status', header: 'Status' },
      { field: 'village', header: 'Village' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});

        doc.save(`${filename}.pdf`);
      });
    });
  }

  hideDialog() {
    this.addBankDialog = false;
    this.submitted = false;
  }

  // printForm(appId, statusCode) {
  //   if (appId) {
  //     let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
  //     // this.router.navigate(['department', 'print', appId], { queryParams: { statusCode: statusCodeEncrypted } });
  //     const link = this.router.serializeUrl(this.router.createUrlTree(['department', 'print', appId], { queryParams: { statusCode: statusCodeEncrypted } }));
  //     window.open(link, '_blank');
  //   } else {
  //     this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
  //   }
  // }
  printForm(appId, statusCode) {
    // if (appId) {
    //   this.router.navigate(['department', 'print', appId]);
      // this.loader.start();
      // this.dashboard
      //   .getMIDetailByAppID(appId)
      //   .pipe(first())
      //   .subscribe({
      //     next: (res) => {
      //       this.loader.close();
      //       let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      //       this.router.navigate(
      //         [
      //           'department',
      //           'print',
      //           appId,
      //           res[0]?.VendorId,
      //           res[0]?.ProgId,
      //           res[0]?.User_ID,
      //           res[0]?.AutoId,
      //         ],
      //         { queryParams: { statusCode: statusCodeEncrypted } }
      //       );
      //     },
      //     error: (err) => {
      //       this.loader.close();
      //       console.log('error', err);
      //       this.activityRecordService.activityRecord(this.userID, 'View Farmer Applications For Approval', appId, new Date(), err);
      //       this.messageService.add({
      //         severity: 'error',
      //         summary: 'Error Message',
      //         detail: err,
      //       });
      //     }
      //   });
      // let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      //   this.router.navigate(['department', 'print',appId], { queryParams: { statusCode: statusCodeEncrypted } });
    // }
    
    if (appId) {
      let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'appliaction-approval', 'print', appId], { queryParams: { statusCode: statusCodeEncrypted } }));
      window.open(link, '_blank');
    }
    else{
      this.messageService.add({
        summary: 'Error Message',
        severity: 'info',
        detail: 'Application Id Not Found',
      });
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'App User Type': d.AppUserType,
          'APP ID': d.appID,
          'Farmer Name': d.farmerName,
          'Applicant Type': d.ApplicantType,
          'Next Level ID': d.NextLevelID,
          'Scheme Code': d.Scheme_Code,
          'Target Days': d.TargetDays,
          Block: d.block,
          District: d.district,
          'Registration Date': d.registerationDate,
          Remarks: d.remarks,
          Status: d.status,
          Village: d.village,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  rowBackgroundColor(row) {
    if (row.Status_Ar == 'P') {
      if (row.PendingCompletedDays <= -2) {
        return '#ff8080';
      } else if (row.PendingCompletedDays == -1) {
        return '#ffc966';
      }
    } else if (row.Status_Ar == 'C' || row.Status_Ar == 'A') {
      if (row.PendingCompletedDays >= -1) {
        return '#99e699';
      } else if (row.PendingCompletedDays <= -2) {
        return '#ffb3b3';
      }
    } else return '#ffffff';
  }
}
